import { useParams } from 'react-router-dom';
import { useBankSelectionIndex, ModalStep, BankStepProps } from './hooks';
import { LoadingContainer } from 'views/mutual/loading';
// import { LeaseFundContractConfirm } from './contractConfirm';
// import { ContractDocumentCheck } from './contractDocumentCheck';
// import { LeaseFundContractComplete } from './contractComplete';
import { useEffect, Dispatch, SetStateAction, useState } from 'react';
import { NotFoundData, NotFoundDataBackPageType } from 'views/mutual/notFoundData';
import { SearchBank, SearchBranch } from 'views/templates/module/bankDetailsInput/modal/searchBank';
import { SelectBank, SelectBranch } from 'views/templates/module/bankDetailsInput/modal/selectBank';
// import { ContractCanceled } from './contractCanceled';

import { useMessageModal } from 'views/mutual/modal/messageModal/hooks';
import { MessageModal } from 'views/mutual/modal/messageModal';
import { Title, Selected, Message, BankButton, BankButtonProps, BankButtonType } from './module';
import './style.scss';

type BankModalProps = {
  onClosed: () => void;
  onSelectedBank: (value: string) => void;
  onSelectedBranch: (value: string) => void;
};

export const BankModal = (props: BankModalProps) => {
  const {
    bankModalStep,
    setBankModalStep,
    bankList,
    setBankList,
    branchList,
    setBranchList,
    title,
    bankName,
    setLocalBankName,
    message,
  } = useBankSelectionIndex();
  return (
    <div className="bankModal">
      <Title title={title} />
      <Selected bankName={bankName} />
      <Message message={message} />
      <BankBody
        bankName={bankName}
        bankList={bankList}
        setBankList={setBankList}
        branchList={branchList}
        setBranchList={setBranchList}
        onClosed={props.onClosed}
        onSelectedBank={(value: string) => {
          props.onSelectedBank(value);
          setLocalBankName(value);
        }}
        onSelectedBranch={props.onSelectedBranch}
        modalStep={bankModalStep}
        setModalStep={setBankModalStep}
      />
    </div>
  );
};

type BankBodyPorps = {
  bankName: string;
  bankList: string[];
  setBankList: Dispatch<SetStateAction<string[]>>;
  branchList: string[];
  setBranchList: Dispatch<SetStateAction<string[]>>;
} & BankModalProps &
  BankStepProps;

const BankBody = ({
  bankName,
  bankList,
  setBankList,
  branchList,
  setBranchList,
  onClosed,
  onSelectedBank,
  onSelectedBranch,
  modalStep,
  setModalStep,
}: BankBodyPorps) => {
  switch (modalStep) {
    case ModalStep.SearchBank:
      return (
        <SearchBank
          type={BankButtonType.none}
          modalStep={modalStep}
          setModalStep={setModalStep}
          setBankList={setBankList}
        />
      );
    case ModalStep.SelectBank:
      return (
        <SelectBank
          onSelected={onSelectedBank}
          type={BankButtonType.backAndNext}
          modalStep={modalStep}
          setModalStep={setModalStep}
          bankList={bankList}
        />
      );
    case ModalStep.SearchBranch:
      return (
        <SearchBranch
          bankName={bankName!}
          back={() => setModalStep(ModalStep.SelectBank)}
          type={BankButtonType.backOnly}
          modalStep={modalStep}
          setModalStep={setModalStep}
          setBranchList={setBranchList}
        />
      );
    case ModalStep.SelectBranch:
      return (
        <SelectBranch
          onSelected={onSelectedBranch}
          onClosed={onClosed}
          type={BankButtonType.backAndNext}
          modalStep={modalStep}
          setModalStep={setModalStep}
          branchList={branchList}
        />
      );
  }
};
